"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck, CalendarCheck, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourVisit() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="133753" id="ready-for-clarity" className="dark bg-[#0b121f] text-slate-50 relative py-24 px-6 overflow-hidden flex flex-col items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#3b49df]/10 rounded-full blur-[120px] opacity-40" />
      </div>

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold tracking-tighter text-slate-50 mb-8 leading-tight">
          Ready for Clarity?
        </h2>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center mb-16">
          <Button asChild size="lg" className="h-14 px-10 text-base rounded-full bg-[#3b49df] hover:bg-[#2d3aba] text-white shadow-xl shadow-indigo-500/20">
            <Link to="/PatientBookingPage">
              <CalendarCheck className="mr-2 size-5" />
              Schedule a Consultation
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-14 px-10 text-base rounded-full border-slate-700 hover:bg-white/5 text-slate-200">
            <Link to="/FamilySupportPage">
              <MapPin className="mr-2 size-5" />
              Support for Families
            </Link>
          </Button>
        </div>

        <div className="flex flex-col items-center gap-6 pt-8 border-t border-slate-800/50 w-full max-w-md">
          <div className="flex items-center gap-2 text-slate-400">
            <ShieldCheck className="size-4" />
            <span className="text-sm uppercase tracking-[0.2em] font-medium">
              Trusted Guidance
            </span>
          </div>
          
          <div className="flex items-center justify-center gap-8 opacity-30 grayscale brightness-150 contrast-125 hover:opacity-60 transition-opacity duration-500">
            
            
          </div>
        </div>
      </div>
    </section>;
}